import {
  ADMIN_API,CENTROS_API
} from "@/config";

export const apiConstants = {
  auth: `${CENTROS_API}/auth`,
  userLogged : `${CENTROS_API}/auth/user`,
}
